import { Bookmark, Heart, type LucideIcon, ShieldCheck, Sparkles } from "lucide-preact";
import { Section, SectionHeading } from "./Section";

type Perk = { icon: LucideIcon; title: string; text: string };

const PERKS: Perk[] = [
  { icon: Heart, title: "Follow your favourites", text: "Find authors you love and see their new articles first." },
  { icon: Bookmark, title: "Save for later", text: "Keep articles in collections, so the good ones never get lost." },
  { icon: Sparkles, title: "Picks made for you", text: "The more you read, the better your daily suggestions get." },
  { icon: ShieldCheck, title: "No ads, no paywall", text: "Free forever and unlimited. Emails only arrive if you ask for them." },
];

const PerkCard = ({ icon: Icon, title, text }: Perk) => (
  <div class="flex gap-4">
    <Icon class="shrink-0 w-6 h-6 mt-1 text-purple-500" />
    <div>
      <h3 class="font-bold text-gray-900 dark:text-gray-50">{title}</h3>
      <p class="mt-1 text-gray-600 dark:text-gray-300">{text}</p>
    </div>
  </div>
);

export const Perks = () => (
  <Section>
    <SectionHeading
      title="A free account makes it yours"
      intro="Read as a guest as long as you like. An account is free forever, with no limits, and gives the things you care about a home."
    />
    <div class="grid gap-8 sm:grid-cols-2 max-w-3xl mx-auto">
      {PERKS.map((perk) => (
        <PerkCard key={perk.title} {...perk} />
      ))}
    </div>
  </Section>
);
